export class RecoverPasswordRequest {
  email: string;
}
